import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format,parseISO } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";
import { NavLink } from "react-router-dom";
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import Select from 'react-select';
import {
  startOfWeek,
  endOfWeek,
  addWeeks,
  startOfYear,
  isAfter,
} from 'date-fns';

// Material UI Component
import {
        FormGroup,
        FormLabel,
        FormControl,
        // ListItemText,
        TextField,
        // Checkbox,
        // FormControlLabel,
        Grid,
        InputLabel,
        Input,
        // MenuItem,
        Modal,
        Backdrop,
        Fade,
        FormHelperText,
        NativeSelect,
        Button,
        Breadcrumbs,
        Typography,
} from "@material-ui/core";
import { makeStyles, createMuiTheme, MuiThemeProvider} from "@material-ui/core/styles";

// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
//cookies
import {get_cookies} from "../../../components/Cookies/Cookies";
import numeral from "numeral";
import { useParams, useHistory,useLocation } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
        modal: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
        },
}));

const AccountUpgradeReportView = (props) => {
        // const { from, to } = useParams();
          const location = useLocation();
 const refViewData = props.location?.state?.refViewData ?? [];
        const [uniqueID, setUniqueId] = useState('');
        const [posts, setPosts] = useState([]);
        const [dataLoaded, setDataLoaded] = useState(false);
        const [open, setOpen] = useState(false);
        const [downloadFlag, setDownloadFlag] = useState(false);
        const [modalOpen, setModalOpen] = useState(false);
        const [dateRange, setDateRange] = useState({
                startDate: startOfWeek(new Date(), { weekStartsOn: 1 }),
                endDate: endOfWeek(new Date(), { weekStartsOn: 1 }),
        });
        const [weekOptions, setWeekOptions] = useState([]);
        const [selectedWeek, setSelectedWeek] = useState(null);
        const [disableBtn, setDisableBtn] = useState(true);

        const classes = useStyles();
        
        const [useridNo, setuseridNo] = useState(get_cookies('branchidno'));
        // console.log(uniqueID);
        // Data Fetching
        useEffect(() => {
                console.log('test',refViewData);
                dataFilter();
        }, []);

        useEffect(() => {
                if(posts.length > 0){
                        setDownloadFlag(true);
                }else{
                        setDownloadFlag(false);
                }
        }, [posts]);
        //search button
        const dataFilter = async () => {

                console.log('weerk');
        //         setDataLoaded(false);
        await axios.get(
                        process.env.REACT_APP_API_URL+'get_accountupgrade_report_view', {
            params:{
                // date_from: from, //format(dateRange.startDate, "yyyy/MM/dd/")
                data: [refViewData],  //format(dateRange.endDate, "yyyy/MM/dd/")
                jc_user_id_no: useridNo,
                                unique_id: uniqueID
            }
        }).then((res)=>{
                console.log('view',res)
                        setPosts(res.data);
                }).catch((error)=>{
                        // console.log(error.message);
                })
                setDataLoaded(true);
    }

        const data = async () => {
                setDataLoaded(true);
        };

        const toggle = () => setOpen(!open);

        const handleModalOpen = () => {
                setModalOpen(true);
        };

        const handleModalClose = () => {
                setModalOpen(false);
        };


        // const dateRangeHandler = (range) => {
        //         const start = startOfWeek(range.startDate, { weekStartsOn: 1 }); // Monday
        //         const end = endOfWeek(range.endDate, { weekStartsOn: 1 });       // Sunday
              
        //         setDateRange({ startDate: start, endDate: end });
        //         setOpen(false);
        //       };
        const columns = [
                {
                        name: "date_paid",
                        label: "Date Paid",

                      },
                      {
                        name: "date_released",
                        label: "Date Released",

                      },
                                                            {
                        name: "reference_number",
                        label: "Type",
                            options: {
                                            customBodyRenderLite: (dataIndex) => {
                                              const type = posts[dataIndex].reference_number;
                                              const transactiontype = posts[dataIndex].upgrade;
                                              let text = "";
                                
                                if(/^GAU/.test(type)){
                                        text ="Upgrade"
                                }
                                
                                else{
                                  text = "New";
                                }
                                          
                                              return (
                                           text
                                              );
                                            },
                            }


                },
                                      {
                        name: "idno",
                        label: "ID No",
                },
                {
                        name: "fullname",
                        label: "Name",
                },
                {
                        name: "reference_number",
                        label: "Reference No",
                },
                {
                        name: "atype",
                        label: "Account Type",

                },
                // {
                //         name: "amount",
                //         label: "Amount(USD)",
                //               options: {
                //                 customHeadRender: (columnMeta) => {
                //                         return (
                //                           <th key={columnMeta.index} style={{ textAlign: "right", paddingRight: "16px" }}>
                //                             <div style={{ textAlign: "right", fontWeight:"400",textTransform:"none"  }}>Amount ({get_cookies('curcode')})</div>
                //                           </th>
                //                         );
                //                       },
                //                 customBodyRender: (value, tableMeta, updateValue) => {
                //                   return (
                //                     <div style={{ textAlign: "right" }}>
                //                       {numeral(value).format("0,0.00")}
                //                     </div>
     
                //                   );
                //                 },
                //                 setCellHeaderProps: () => ({
                //                         style: { alignItems: "flex-end", },
                //                       }),
                //                       setCellProps: () => ({
                //                         style: { textAlign: "right" },
                //                       }),
                                  
                //               },
                // },
                {
                        name: "amount_php",
                        label: "Amount PHP",
                        options: {
                                customHeadRender: (columnMeta) => {
                                        return (
                                          <th key={columnMeta.index} style={{ textAlign: "right", paddingRight: "16px" }}>
                                            <div style={{ textAlign: "right",fontWeight:"400",textTransform:"none"  }}>Amount (PHP)</div>
                                          </th>
                                        );
                                      },
                                customBodyRender: (value, tableMeta, updateValue) => {
                                  return (
                                    <div style={{ textAlign: "right" }}>
                                      {numeral(value).format("0,0.00")}
                                    </div>
     
                                  );
                                  
                                },
                                setCellHeaderProps: () => ({
                                        style: { justifyContent: "flex-end", display: "flex" },
                                      }),
                                      setCellProps: () => ({
                                        style: { textAlign: "right" },
                                      }),
                                  
                              },
                },


                {
                        name: "is_encashed",
                        label: "Status",
                        options: {
                                customBodyRenderLite: (dataIndex)=> {
                                        let is_released =  posts[dataIndex].is_encashed;
                                        if(is_released == 1){

                                                return`Encashed`;
                                        }else{
                                                return`Processing`;
                                        }
                                  

                                      }
                              }
                },

        ];

        const options = {
                filter: false,
                // filterType: "dropdown",
                selectableRows: "none",
                filterType: "multiselect",
                responsive: "standard",
                download: false,  //add this
                print: false, //add this
                viewColumns :false,
                setFilterChipProps: (colIndex, colName, data) => {
                        //console.log(colIndex, colName, data);
                        return {
                                color: "primary",
                                variant: "outlined",
                                className: "testClass123",
                        };
                },
                customTableBodyFooterRender: () => {
                        const total = posts.reduce((sum, row) => sum + parseFloat(row.amount_php || 0), 0);
                    
                        return (
                          <TableFooter>
                            <TableRow >
                              <TableCell colSpan={columns.length - 2} align="right" style={{ fontWeight: 'bold',color:"black" }}>
                                Total:
                              </TableCell>
                              <TableCell style={{ fontWeight: 'bold' ,color:"black",borderWidth:1,textAlign:'right'}}>
                                {numeral(total).format("0,0.00")}
                              </TableCell>
                              <TableCell style={{ fontWeight: 'bold' ,color:"black",borderWidth:1}}>
                               
                              </TableCell>
                            </TableRow>
                          </TableFooter>
                        );
                      }

                // tableBodyHeight,
        };

    const style = {
                marginBottom: '1rem',
                marginTop:"2.5em",
        };

        return (
                <div className="page">
                        <div className="page-header">
                                <div className="page-icon">
                                        <ShoppingCartIcon />
                                </div>
                                <Breadcrumbs aria-label="breadcrumb">
                                        <NavLink to="/reports">
                                                <h2 className="header-title">Reports</h2>
                                        </NavLink>  
                                        <Typography color="textPrimary">Wholesale Set Payout Summary Report</Typography>
                                </Breadcrumbs>
                        </div>
                        <div className="page-container">


                                {!dataLoaded ? (
                                        <Preloader />
                                ) : (
                                        <> <MUIDataTable
                                                        title={
                                                                <div>
                                                                        <h3 className="header-title" style ={{color: "#339933"}}>
                                                                        Wholesale Set  Payout Summary Report
                                                                        </h3>
                                                                </div>
                                                        }
                                                        data={posts}
                                                        columns={columns}
                                                        options={options}
                                                />
                                                            <div style={{ textAlign: "right", marginBottom: "1rem" }}>
                                                              <NavLink
                                                                to="/reports/account-upgrade-report"
                                                                style={{
                                                                  backgroundColor: "#339933",
                                                                  color: "#fff",
                                                                  padding: "10px 16px",
                                                                  borderRadius: "6px",
                                                                  textDecoration: "none",
                                                                  fontWeight: "bold",
                                                                  display: "inline-block",
                                                                  marginTop:"10px",
                                                                }}
                                                              >
                                                                Back
                                                              </NavLink>
                                                            </div>
                                                </>
                                               
                                )}
                        </div>
                </div>
        );
};

export default AccountUpgradeReportView;